export const wooSettings = [
	{
		id    : 'show_on_woocommerce',
		label : 'Show on all WooCommerce pages',
		help  : 'The campaign will show on any page where WooCommerce templates are used.',
		show  : '-never-',
	},
	{
		id    : 'is_wc_shop',
		label : 'Product Archive Page (shop)',
		help  : 'The campaign will show on the product archive page (shop).',
		show  : 'Inline', /* Don't show if output can't use the_content filter */
	},
	{
		id    : 'is_wc_product',
		label : 'Single Product',
		help  : 'The campaign will show on any single product.',
	},
	{
		id    : 'is_wc_cart',
		label : 'Cart',
		help  : 'The campaign will show on the cart page.',
	},
	{
		id    : 'is_wc_checkout',
		label : 'Checkout Page',
		help  : 'The campaign will show on the checkout page.',
	},
	{
		id    : 'is_wc_account',
		label : 'Customer Account Page',
		help  : 'The campaign will show on the customer account page.',
	},
	{
		id    : 'is_wc_endpoint',
		label : 'Show on all WooCommerce Endpoints',
		help  : 'The campaign will show on any WooCommerce endpoint.',
	},
	{
		id    : 'is_wc_endpoint_order_pay',
		label : 'Order Pay Endpoint',
		help  : 'The campaign will show when the endpoint page for order pay is displayed.',
	},
	{
		id    : 'is_wc_endpoint_order_received',
		label : 'Order Received Endpoint',
		help  : 'The campaign will show when the endpoint page for order received is displayed.',
	},
	{
		id    : 'is_wc_endpoint_view_order',
		label : 'View Order Endpoint',
		help  : 'The campaign will show when the endpoint page for order received is displayed.',
	},
	{
		id    : 'is_wc_endpoint_edit_account',
		label : 'Edit Account Endpoint',
		help  : 'The campaign will show when the endpoint page for edit account is displayed.',
	},
	{
		id    : 'is_wc_endpoint_edit_address',
		label : 'Edit Address Endpoint',
		help  : 'The campaign will show when the endpoint page for edit address is displayed.',
	},
	{
		id    : 'is_wc_endpoint_lost_password',
		label : 'Lost Password Endpoint',
		help  : 'The campaign will show when the endpoint page for lost password is displayed.',
	},
	{
		id    : 'is_wc_endpoint_customer_logout',
		label : 'Logout Endpoint',
		help  : 'The campaign will show when the endpoint page for logout is displayed.',
	},
	{
		id    : 'is_wc_endpoint_add_payment_method',
		label : 'Add Payment Method Endpoint',
		help  : 'The campaign will show when the endpoint page for add payment method is displayed.',
	},
]
